import { fetcher } from "@/shared/core-configs";
import { API } from "@/config";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AliasProductInput } from "../types/AliasProduct";
import { GET_ALIAS_PRODUCTS_FETCH_KEY } from "./useGetAliasProducts";

export const updateAliasProduct = async (
  id: string,
  updateAliasProduct: Partial<AliasProductInput>,
): Promise<AliasProductInput> => {
  const response = await fetcher.put(
    `${API.GESLUB}/alias-product/${id}`,
    updateAliasProduct,
  );
  return response.data;
};

export const useUpdateAliasProduct = () => {
  const queryClient = useQueryClient();
  const mutation = useMutation<
    AliasProductInput,
    Error,
    { id: string; updateAliasProducts: Partial<AliasProductInput> }
  >({
    mutationFn: async ({ id, updateAliasProducts }) => {
      return updateAliasProduct(id, updateAliasProducts);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [GET_ALIAS_PRODUCTS_FETCH_KEY],
      });
    },
  });
  return {
    mutate: mutation.mutate,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    isPending: mutation.isPending,
    error: mutation.error,
  };
};
